import React, { lazy, Suspense, useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import Loading from "./components/shared-components/Loading";
import { Urls } from "./Urls";
import ErrorTwo from "./Errors/error-page-2";
import InviteV2 from "./Onboarding/InviteV2";

const Login = lazy(() => import(`./PublicViews/Login`));
const Signup = lazy(() => import(`./PublicViews/Register`));
const Verify = lazy(() => import(`./PublicViews/Verify`));
const ForgotPassword = lazy(() => import(`./PublicViews/Forgot`));
const chooseBot = lazy(() => import(`./admin-views/chooseBot`));
const Home = lazy(() => import(`./Home`));
const Profile = lazy(() => import(`./Settings/Profile/Profile`));
const Onboarding = lazy(() => import(`./Onboarding`));

const ProtectedRoute = ({ path }) => {
	return <Route path={path} component={Home} />;
};

function Routes() {
	const { authenticated = true } = useSelector((state) => state.auth);
	const [invalidUrl, setInvalidUrl] = useState(false);

	useEffect(() => {
		if (Object.values(Urls).indexOf(window.location.pathname) == -1) {
			setInvalidUrl(true);
		}
	}, [Urls]);

	return (
		invalidUrl ? (<ErrorTwo />) : (
			<Suspense fallback={<Loading cover="content" />}>
				<Router>
					<Switch>
						<Redirect from="/" exact to={Urls.HOME} />
						<Route exact path={Urls.LOGIN} component={Login} />
						<Route exact path={Urls.ONBOARDING} component={Onboarding} />
						<Route exact path={Urls.SIGNUP} component={Signup} />
						<Route exact path={Urls.SIGNUPV2} component={InviteV2} />
						<Route exact path={Urls.VERIFY} component={Verify} />
						<Route exact path={Urls.FORGOT_PASSSWORD} component={ForgotPassword} />
						<Route exact path={Urls.HOME} component={chooseBot} />
						<Route exact path={Urls.PROFILE} component={Profile} />
						{authenticated &&
							<ProtectedRoute path={"/"}
							/>}

					</Switch>
				</Router>
			</Suspense>
		)
	);
}

const mapStateToProps = ({ auth }) => {
	const { token } = auth;
	return { token };
};

export default connect(mapStateToProps)(Routes);
